import React from 'react';
import ActivityTimeline from '../../components/ActivityTimeline';

// The account's entries, newest first, on the shared timeline.
function AccountActivitiesTab({ account }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Activities</h3>
      </div>
      <div className="card-body">
        {account.activities?.length > 0 ? (
          <ActivityTimeline activities={account.activities} showAccount={false} />
        ) : (
          <p className="text-secondary text-center">No activities logged. Press ⌘J (Ctrl+J) and say what happened.</p>
        )}
      </div>
    </div>
  );
}

export default AccountActivitiesTab;
